module.exports = __webpack_public_path__ + "static/img/voucher.820b4784.png";